import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "../styles/App.css";
import "@amzn/meridian";
import zoomSdk from "@zoom/appssdk";
import Home from "./pages/Home";
import BraveheartHome from "./braveheart/Home";
import Login from "./pages/Login";
import Summaries from "./inMeeting/././summary/Summaries";
import SummaryDetail from "./inMeeting/././summary/SummaryDetails";
import SummaryDetailInClient from "./inMainClient/./summaryTab/SummaryDetailInClient";
import MainClientHome from "./inMainClient/MainClientHome";
import LogManager from "./utils/LogManager";
import { fetchFeatureFlags } from "./utils/FeatureFlagUtil";
import { ALLOWLIST_FLAGS, PERCENTAGE_FLAGS, BRAVEHEARTS_FLAGS } from "../featureFlags";

import Loading from "./common/Loading";

const App = () => {
  const [lastKnownContext, setLastKnownContext] = useState(null);
  const [featureFlags, setFeatureFlags] = useState(null); // null = loading

  useEffect(() => {
    const loadFeatureFlags = async () => {
      if (window.location.href === "http://localhost:3000/") {
        setFeatureFlags({
          isBraveheartUser: true,
          isVerboseSummariesEnabled: true,
        });
        return;
      }
      try {
        const flags = await fetchFeatureFlags({
          bravehearts: [BRAVEHEARTS_FLAGS.IS_ELIGIBLE],
          allowlist: [ALLOWLIST_FLAGS.VERBOSE_SUMMARIES],
          percentage: [PERCENTAGE_FLAGS.VERBOSE_SUMMARIES],
        });
        const resolvedFlags = {
          isBraveheartUser: flags?.[BRAVEHEARTS_FLAGS.IS_ELIGIBLE] === true,
          isVerboseSummariesEnabled: flags?.[ALLOWLIST_FLAGS.VERBOSE_SUMMARIES] === true
            || flags?.[PERCENTAGE_FLAGS.VERBOSE_SUMMARIES] === true,
        };
        LogManager.info("Feature flags resolved:", JSON.stringify(resolvedFlags));
        console.log("Feature flags resolved:", resolvedFlags);
        setFeatureFlags(resolvedFlags);
      } catch (error) {
        LogManager.error("Error fetching feature flags:", error);
        setFeatureFlags({ isBraveheartUser: false, isVerboseSummariesEnabled: false });
      }
    };
    loadFeatureFlags();
  }, []);

  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (window.location.pathname.startsWith("/client") && document.visibilityState === 'visible' && lastKnownContext === "inMainClient") {
        LogManager.info('App became visible on client route, checking context...');
        try {
          const newContext = await zoomSdk.getRunningContext();
          LogManager.info(`Current SDK context: ${newContext.context}, Last known context: ${lastKnownContext}`);
          
          if (newContext.context !== lastKnownContext) {
            LogManager.info(`Context changed from ${lastKnownContext} to ${newContext.context}`);
            if (newContext.context === "inMeeting") {
              window.location.href = `${window.location.origin}/`;
            }
          }
          setLastKnownContext(newContext.context);
        } catch (error) {
          LogManager.error('Error checking context:', error);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [lastKnownContext]);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/meeting/summary" element={<Summaries />} />
        <Route path="/meeting/summary/:id" element={<SummaryDetail />} />
        <Route path="/client" element={<MainClientHome featureFlags={featureFlags} />} />
        <Route path="/client/summary/:id" element={<SummaryDetailInClient />} />
        <Route path="*" element={
          featureFlags === null 
            ? <Loading />
            : featureFlags.isBraveheartUser 
              ? <BraveheartHome setLastKnownContext={setLastKnownContext} featureFlags={featureFlags} />
              : <Home setLastKnownContext={setLastKnownContext} featureFlags={featureFlags} />
        } />
      </Routes>
    </Router>
  );
};

export default App;
